const ENV = process.env.REACT_APP_NODE_ENV;
const BASE_URL_SSD = ENV === 'production' ? process.env.REACT_APP_BASE_URL_SSD : (ENV === 'staging' || ENV === 'development' ) ? process.env.REACT_APP_BASE_URL_SSD_STAGING : 'http://localhost:8080/api';

export const getCDGRJobsApi = async () => {
  try {
    const options = {
      method: 'GET',
      headers: {
        'x-api-key': process.env.REACT_APP_API_KEY,
        'Content-Type': 'application/json',
        'cache': 'no-store'
      },
    };

    let result = await fetch(`${BASE_URL_SSD}/cdgrjobs`, options);

    if (result.status === 200) {
      return result.json();
    };
  } catch (error) {
    console.log(error);
    return null;
  };
};

export const loadCDGRJobApi = async (location) => {
  try {
    let result = await fetch(location, {cache: "no-store"});

    if (result.status === 200) {
      return result.json();
    };
  } catch (error) {
    console.log(error);
    return null;
  };
};

export const saveCDGRJobApi = async (cdgrJob) => {
  try {
    const options = {
      method: 'POST',
      headers: {
        'x-api-key': process.env.REACT_APP_API_KEY,
        'Content-Type': 'application/json'
      },
      cache: 'no-store',
      body: JSON.stringify({jobsummary: cdgrJob})
    };

    const result = await fetch(`${BASE_URL_SSD}/cdgrjobs`, options);

    if (result.status === 200) {
      return result.json();
    } else {
      return null;
    };
  } catch (error) {
    console.log(error);
    return null;
  };
};

export const deleteCDGRJobApi = async (cdgrJobId, userEmail) => {
  try {
    const options = {
      method: 'DELETE',
      headers: {
        'x-api-key': process.env.REACT_APP_API_KEY,
        'Content-Type': 'application/json',
        'cdgrjobid': cdgrJobId,
        'email': userEmail
      },
      cache: 'no-store'
    };

    console.log(`Deleting CDGR job with id ${cdgrJobId}...`);
    await fetch(`${BASE_URL_SSD}/cdgrjobs`, options);

  } catch (error) {
    console.log(error);
    return null;
  };
};
